export default __webpack_public_path__ + "static/media/github.a9678d95.png";